export default function ProductsClosing() {
  return (
    <section className="py-14 md:py-20 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 border-t border-graphite-700 pt-12">
            <div className="max-w-xl">
              <h2 className="text-xl md:text-2xl font-bold text-white mb-3">
                Built to work together
              </h2>
              <p className="text-sm md:text-base text-silver-300 leading-relaxed">
                Every StackMap product connects natively. Data flows from the field into reports,
                from tasks into payroll, and from audits into action without integrations, imports, or workarounds.
              </p>
            </div>

            <div className="flex items-center gap-8 shrink-0">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">12</div>
                <div className="text-xs text-silver-400 uppercase tracking-wider">BOS Modules</div>
              </div>
              <div className="w-px h-10 bg-graphite-700" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">1</div>
                <div className="text-xs text-silver-400 uppercase tracking-wider">Vertical SaaS</div>
              </div>
              <div className="w-px h-10 bg-graphite-700" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">0</div>
                <div className="text-xs text-silver-400 uppercase tracking-wider">Integrations Needed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
